import React from 'react'
import { Form, FormikProps } from 'formik'
import { ILanguages } from '../../types/languages'
import { IPackInput } from '../../types/pack'
import { StyledFormActionWrapper } from '../../layouts'
import { Button } from '../../components'
import { PackFormFragment } from './PackFormFragment'

interface IPackForm {
  languages: ILanguages
  cancelAction?: () => void
  submitText?: string
  formikProps: FormikProps<IPackInput>
}

export const PackForm = ({
  submitText = 'Submit',
  languages,
  cancelAction,
  formikProps,
}: IPackForm) => (
  <Form>
    <PackFormFragment formikProps={formikProps} languages={languages} />
    <StyledFormActionWrapper>
      <Button id="cancel-button" onClick={cancelAction}>
        Cancel
      </Button>
      <Button
        id="submit-form-data"
        type="submit"
        variant="contained"
        color="primary"
        disabled={
          !formikProps.isValid ||
          (formikProps.status && formikProps.status.submitDisabled)
        }
      >
        {submitText}
      </Button>
    </StyledFormActionWrapper>
  </Form>
)
